import React, { useEffect, useState } from 'react';
import styles from './Landing.module.css';
import logoFull from '../../assets/images/logo-full.png';
import Footer from '../../components/footer/Footer';
import Header from '../../components/header/Header';
// import TestimonialsSection from '../../components/testimonials/TestimonialsSection';
import FAQSection from './components/FAQSection';
import FeaturesSection from './components/FeaturesSection';
import SecuritySection from './components/SecuritySection';
import PlansSection from './components/PlansSection/PlansSection';
import PainPointsSection from './components/PainPointsSection';
// import MetricsSection from './components/MetricsSection';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ScarcityBanner from './components/ScarcityBanner';
import VideoSection from './components/VideoSection';
import CtaSection from './components/CtaSection/CtaSection';
import RegisterModal from './components/RegisterModal/RegisterModal';
import ReferralBanner from './components/ReferralBanner/ReferralBanner';
import { LookupReferralCodeAPI } from '../../api/ReferralAPI';
import { getReferralCode, clearReferralCode } from '../../utils/referralCode';

// Segment resolution function - now fetches data dynamically
async function resolveSegment(seg) {
  try {
    const response = await fetch('/data/segments.json');
    const segments = await response.json();
    return segments[seg] || segments.generic;
  } catch (error) {
    // Fallback configuration
    return {
      heroTitle: "Mais organização para o seu dia. Mais tempo para o que importa.",
      heroSubtitle: "A Gabriela reúne agenda, pacientes, prontuários, documentos, financeiro e comunicação em um só lugar.",
      heroImg: "/img/hero-generic.png",
      testimonialRef: "/data/lp/testimonials/testimonials.json"
    };
  }
}

// Testimonial resolution function
async function resolveTestimonial(testimonialRef, segment) {
  // Don't show testimonials in hero for generic segment
  if (segment === 'generic') {
    return null;
  }
  
  try {
    const response = await fetch(testimonialRef);
    const testimonials = await response.json();
    return testimonials[0]; // Return first testimonial for hero
  } catch (error) {
    return null;
  }
}

function Landing() {
  // State for segment configuration and testimonial data
  const [segmentConfig, setSegmentConfig] = useState(null);
  const [heroTestimonial, setHeroTestimonial] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  // Estado do modal de cadastro
  const [isRegisterModalOpen, setIsRegisterModalOpen] = useState(false);
  const openRegisterModal = () => setIsRegisterModalOpen(true);
  const closeRegisterModal = () => setIsRegisterModalOpen(false);

  // Indique e ganhe: quem chegou por /i/CODIGO vê o nome de quem indicou
  const [referrerName, setReferrerName] = useState(null);
  const [referralBannerOpen, setReferralBannerOpen] = useState(true);
  useEffect(() => {
    const code = getReferralCode();
    if (!code) return;
    LookupReferralCodeAPI(code, (response) => {
      if (response && response.success && response.company?.name) {
        setReferrerName(response.company.name);
      } else if (response && response.success === false && !response.error) {
        // Código que não existe (resposta do servidor, não falha de rede): esquece
        clearReferralCode();
      }
    });
  }, []);

  // Get segment from URL parameters
  const seg = new URLSearchParams(window.location.search).get("especialidade") || "generic";
  // Função para aguardar o gtag estar disponível
  const waitForGtag = (callback, maxAttempts = 10, interval = 500) => {
    let attempts = 0;
    
    const checkGtag = () => {
      attempts++;
      
      if (typeof window !== 'undefined' && window.gtag) {
        callback();
        return;
      }
      
      if (attempts < maxAttempts) {
        setTimeout(checkGtag, interval);
      }
    };
    
    checkGtag();
  };

  // Effect to load segment configuration and testimonial data
  useEffect(() => {
    const loadSegmentData = async () => {
      try {
        setIsLoading(true);
        
        // Resolve segment configuration
        const cfg = await resolveSegment(seg);
        setSegmentConfig(cfg);
        setIsLoading(false);
      } catch (error) {
        // Fallback to generic segment
        const genericCfg = resolveSegment('generic');
        setSegmentConfig(genericCfg);
        setIsLoading(false);
      }
    };

    loadSegmentData();
  }, [seg]);

  // Efeito para resetar a posição de scroll quando o componente é montado
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Função mantida por compatibilidade — agora abre o modal em vez de fazer scroll
  const scrollToBetaSection = () => {
    openRegisterModal();
  };

  // Show loading state while data is being fetched
  if (isLoading || !segmentConfig) {
    return (
      <div className={styles.landingContainer}>
        {/* <ScarcityBanner onScrollToBeta={scrollToBetaSection} /> */}
        <Header
          logoSrc={logoFull}
          showBetaButton={true}
          showLoginButton={true}
          showNavigation={true}
        />
        {/* Loading placeholder */}
        <div style={{ minHeight: '400px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <p>Carregando...</p>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.landingContainer}>
      {/* <ScarcityBanner onScrollToBeta={scrollToBetaSection} /> */}
      <Header
        logoSrc={logoFull}
        showBetaButton={true}
        showLoginButton={true}
        showNavigation={true}
        onCreateAccount={openRegisterModal}
      />
      <HeroSection
        onScrollToBeta={scrollToBetaSection}
        title={segmentConfig.heroTitle}
        subtitle={segmentConfig.heroSubtitle}
        imageSrc={segmentConfig.heroImg}
      />
      <PainPointsSection onScrollToBeta={scrollToBetaSection} />
      <VideoSection />
      {/* <MetricsSection /> */}
      <AboutSection onScrollToBeta={scrollToBetaSection} />
      <FeaturesSection onScrollToBeta={scrollToBetaSection} />
      <SecuritySection />
      <PlansSection onOpenModal={openRegisterModal} />
      {/* <TestimonialsSection testimonialRef={segmentConfig.testimonialRef} /> */}
      <CtaSection onOpenModal={openRegisterModal} />
      <FAQSection onScrollToBeta={scrollToBetaSection} />
      <Footer />

      {referrerName && referralBannerOpen && !isRegisterModalOpen && (
        <ReferralBanner
          name={referrerName}
          onCreateAccount={openRegisterModal}
          onDismiss={() => setReferralBannerOpen(false)}
        />
      )}

      {/* Modal de cadastro — overlay global, fora do fluxo normal */}
      <RegisterModal isOpen={isRegisterModalOpen} onClose={closeRegisterModal} referrerName={referrerName} />
    </div>
  );
}

export default Landing;